export default __webpack_public_path__ + "static/media/navbar-icon-provider-products.f6ca3422.svg";